import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StepsModel {

  public settings: any = {};
  public stepsData: any;

  constructor() {
  }

  setSettings(data) {
    if (data) {
      this.settings = data;
    } else {
      this.settings = {};
    }
  }

  getSettings() {
    return this.settings;
  }

  setSteps(data) {
    if (data) {
      this.stepsData = data;
    } else {
      this.stepsData = new Array();
    }
  }

  getSteps() {
    return this.stepsData;
  }

  buildSettingsStep(steps, settingsPortal) {
    if (Object.keys(settingsPortal).length !== 0) {
      for (const key in steps) {
        if (Object.prototype.hasOwnProperty.call(steps, key)) {
          const element = steps[key];
          if (element.background === null) {
            element.background = settingsPortal.background;
          }
        }
      }
      return steps;
    } else {
      return steps;
    }
  }



}
